import { Admin } from '@scribe-sas/types/admin'
import ApiService from 'services/ApiService'
import qs from 'qs'

export default class SignatureTemplatesTransportLayer {
  public async getSignatureTemplate(
    id: number,
  ): Promise<Admin.SignatureTemplatesShow.ResponseBody | null> {
    const response =
      await ApiService.get<Admin.SignatureTemplatesShow.ResponseBody>(
        `/signature_templates/${id}`,
      )
    if (response.outcome === 'success') {
      return response.data
    }
    return null
  }

  public async getSignatureTemplates(
    params: Admin.SignatureTemplatesIndex.RequestQuery,
  ): Promise<Admin.SignatureTemplatesIndex.ResponseBody | null> {
    const response =
      await ApiService.get<Admin.SignatureTemplatesIndex.ResponseBody>(
        `/signature_templates?${qs.stringify(params)}`,
      )
    if (response.outcome === 'success') {
      return response.data
    }
    return null
  }
}
